<template>
  <div class="vx-card p-6">
    <div class="flex flex-wrap" style="font-size: 40px; justify-content: center;">
      TEKNİK VE GARAJ RAPOR YÖNETİMİ
    </div>
    <form class="vx-row" @submit.prevent="technicReport()">
      <div style="width: 100%;">
        <!--1. Row-->
        <div class="vx-row mt-3 ml-2">
          <div class="vx-col md:w-1/6">
            <label class="text-sm"><b>Durum</b></label>
            <v-select @input="technicReport()" name="statusSelection" v-model="selectedStatus" placeholder="Durum Seçiniz" :options="status" label="value" class="w-full">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="vx-col md:w-1/6">
            <label class="text-sm"><b>Atanan Personel</b></label>
            <v-select @input="technicReport()" name="personnelSelection" v-model="selectedPersonnel" placeholder="Personel Seçiniz" :options="personnels" label="userName" class="w-full">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="vx-col md:w-1/6">
            <label class="text-sm"><b>Başlangıç</b></label>
            <input type="date" style="height: 39px;" v-model="startDate" class="vs-inputx vs-input--input medium" />
          </div>
          <div class="vx-col md:w-1/6">
            <label class="text-sm"><b>Bitiş</b></label>
            <input @change="technicReport()" type="date" style="height: 39px;" v-model="dueDate" class="vs-inputx vs-input--input medium" />
          </div>

          <div class="vx-col md:w-1/6">
            <vs-button style="margin-top: 15px; margin-left: 50px;" type="border" color="warning">Görüntüle</vs-button>
          </div>
          <div class="vx-col md:w-1/6">
            <div style="cursor: pointer; width: 100px; margin-top: 15px;" class="px-4 py-1 flex items-center">
              <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
              <JsonExcel :data="reports" class><b>İndir</b></JsonExcel>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!----->

    <vs-table search noDataText="Rapor Bulunamadı!" :data="reports" :pagination="true" :maxItems="10" class="w-full">
      <template slot="thead">
        <vs-th style="width: 30px;">Tarih</vs-th>
        <vs-th style="width: 30px;">Müşteri</vs-th>
        <vs-th style="width: 30px;">Personel</vs-th>
        <vs-th style="width: 30px;">Atanan Personel</vs-th>
        <vs-th style="width: 30px;">Ürün</vs-th>
        <vs-th style="width: 30px;">Durum</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr v-for="(tr, i) in data" :key="i">
          <vs-td>{{ tr.createdDate.substr(0, 10) }}</vs-td>
          <vs-td>{{ tr.customer }}</vs-td>
          <vs-td>{{ tr.personnel }}</vs-td>
          <vs-td>{{ tr.assignedUser }}</vs-td>
          <vs-td>{{ tr.product }}</vs-td>
          <vs-td>{{ tr.status }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";
import JsonExcel from "vue-json-excel";

export default {
  components: {
    vSelect,
    JsonExcel,
  },
  data() {
    return {
      status: [],
      selectedStatus: {}.empty,
      reports: [],
      personnels: [],
      selectedPersonnel: {}.empty,
      selectedAssigned: {}.empty,
      startDate: undefined,
      dueDate: undefined,
    };
  },
  created() {
    Promise.all([this.getStatusList(), this.getUserList()]);
  },
  methods: {
    technicReport: async function () {
      let TechnicReportSearchCriteria = {
        startDate: this.startDate,
        dueDate: this.dueDate,
        assignedUserId: this.selectedPersonnel ? this.selectedPersonnel.userId : undefined,
        statusId: this.selectedStatus ? this.selectedStatus.id : undefined,
      };
      this.reports = await repository.postEntity("Reports/GetTechnicForReport", TechnicReportSearchCriteria).then((r) => r.list);
    },
    getStatusList: async function () {
      this.status = await repository.getAll("Technic/getStatusList").then((r) => r.list);
    },
    getUserList: async function () {
      this.personnels = await repository.getAll("User/getUserList").then((r) => r.list);
    },
  },
};
</script>
